var vars$f = { color: { brand: "var(--b51y2k0)", primary: "var(--b51y2k1)", secondary: "var(--b51y2k2)", danger: "var(--b51y2k3)", gray400: "var(--b51y2k4)", gray500: "var(--b51y2k5)", gray700: "var(--b51y2k6)", gray900: "var(--b51y2k7)", blue600: "var(--b51y2k8)", blue700: "var(--b51y2k9)" }, font: { text: "var(--b51y2ka)", textSm: "var(--b51y2kb)", textMd: "var(--b51y2kc)", textLg: "var(--b51y2kd)", textXxl: "var(--b51y2ke)", textXl: "var(--b51y2kf)", title: "var(--b51y2kg)" }, fontWeight: { normal: "var(--b51y2kh)", semi: "var(--b51y2ki)", semiBold: "var(--b51y2kj)", bold: "var(--b51y2kk)" }, space: { none: "var(--b51y2kl)", sm: "var(--b51y2km)", md: "var(--b51y2kn)", xl: "var(--b51y2ko)", xxl: "var(--b51y2kp)" }, borderRadius: { round: "var(--b51y2kq)", md: "var(--b51y2kr)" } };
var securityVerificationStyle_vanilla$K = "";
var securityVerificationStyle_vanilla$J = "";
var cell = "_13hx4r4k";
var cellContainer = "_13hx4r4j";
var cellFocused = "_13hx4r4m";
var cellWithCaret = "_13hx4r4o";
var cellWithDot = "_13hx4r4n";
var compactCell = "_13hx4r4l";
var containerError = "_13hx4r4g";
var containerFocused = "_13hx4r4f";
var errorIcon = "_13hx4r4i";
var errorText = "_13hx4r4h";
var inputContainer = "_13hx4r4e";
var nativeInput = "_13hx4r4p";
var seperated = "_13hx4r4d";
var vars$e = { compactCellSize: "var(--_13hx4r40)", cellSize: "var(--_13hx4r41)", cellGap: "var(--_13hx4r42)", compactCellGap: "var(--_13hx4r43)", cellBackgroundColor: "var(--_13hx4r44)", focusedCellBorderColor: "var(--_13hx4r45)", dotSize: "var(--_13hx4r46)", borderRadius: "var(--_13hx4r47)", borderColor: "var(--_13hx4r48)", errorTop: "var(--_13hx4r49)", errorBottom: "var(--_13hx4r4a)", errorIconRight: "var(--_13hx4r4b)", errorIconSize: "var(--_13hx4r4c)" };
var input_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  cell,
  cellContainer,
  cellFocused,
  cellWithCaret,
  cellWithDot,
  compactCell,
  containerError,
  containerFocused,
  errorIcon,
  errorText,
  inputContainer,
  nativeInput,
  seperated,
  vars: vars$e
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$I = "";
var button$2 = "sax6uo6";
var disabled = "sax6uo7";
var vars$d = { color: { background: "var(--sax6uo0)", text: "var(--sax6uo1)" }, size: { height: "var(--sax6uo2)" }, font: { size: "var(--sax6uo3)", weight: "var(--sax6uo4)" }, borderRadius: "var(--sax6uo5)" };
var button_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  button: button$2,
  disabled,
  vars: vars$d
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$H = "";
var actions = "dp9gs218";
var backImg = "dp9gs2x";
var countdownText = "dp9gs21i";
var error = "dp9gs216";
var errorImg = "dp9gs217";
var fill = "dp9gs211";
var fillingImg = "dp9gs2y";
var frequentImg = "dp9gs21e";
var frequentText = "dp9gs21g";
var frequentTitle = "dp9gs21f";
var hint = "dp9gs219";
var opStep = "dp9gs21b";
var puzzle = "dp9gs2t";
var puzzleLoading = "dp9gs2u";
var refresh = "dp9gs21c";
var refreshBtn$1 = "dp9gs21h";
var resolved = "dp9gs2v";
var resolvedImg = "dp9gs2w";
var slider$2 = "dp9gs2z";
var sliderCaptcha = "dp9gs2r";
var steps$2 = "dp9gs21a";
var subTitle$5 = "dp9gs2s";
var thumb = "dp9gs212";
var thumbContainer = "dp9gs214";
var thumbFakeContainer = "dp9gs213";
var thumbImg = "dp9gs215";
var tooFrequentlyContainer = "dp9gs21d";
var track = "dp9gs210";
var vars$c = { fontSize: { subTitle: "var(--dp9gs20)" }, color: { loadingBackground: "var(--dp9gs21)", success: "var(--dp9gs22)", error: "var(--dp9gs23)", fill: "var(--dp9gs24)" }, resolvedImg: { size: "var(--dp9gs25)", space: "var(--dp9gs26)" }, borderRadius: { backImg: "var(--dp9gs27)", track: "var(--dp9gs28)", hint: "var(--dp9gs29)" }, size: { track: "var(--dp9gs2a)", fakeThumb: "var(--dp9gs2b)", thumb: "var(--dp9gs2c)", thumbLineHeight: "var(--dp9gs2d)", thumbImgWidth: "var(--dp9gs2e)", thumbImgHeight: "var(--dp9gs2f)", puzzleHeight: "var(--dp9gs2g)", frequentImg: "var(--dp9gs2h)", refresh: "var(--dp9gs2i)" }, space: { subTitle: "var(--dp9gs2j)", thumb: "var(--dp9gs2k)", tooFrequently: "var(--dp9gs2l)", frequentText: "var(--dp9gs2m)", hint: "var(--dp9gs2n)", hintBottom: "var(--dp9gs2o)", step: "var(--dp9gs2p)", refreshBtn: "var(--dp9gs2q)" } };
var slider_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  actions,
  backImg,
  countdownText,
  error,
  errorImg,
  fill,
  fillingImg,
  frequentImg,
  frequentText,
  frequentTitle,
  hint,
  opStep,
  puzzle,
  puzzleLoading,
  refresh,
  refreshBtn: refreshBtn$1,
  resolved,
  resolvedImg,
  slider: slider$2,
  sliderCaptcha,
  steps: steps$2,
  subTitle: subTitle$5,
  thumb,
  thumbContainer,
  thumbFakeContainer,
  thumbImg,
  tooFrequentlyContainer,
  track,
  vars: vars$c
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$G = "";
var title$4 = "_1ka0qbm4";
var vars$b = { color: "var(--_1ka0qbm0)", bottomSpace: "var(--_1ka0qbm1)", titleSize: "var(--_1ka0qbm2)", titleWeight: "var(--_1ka0qbm3)" };
var title_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  title: title$4,
  vars: vars$b
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$F = "";
var content$1 = "g8gmt75";
var loading$3 = "g8gmt73";
var mobileLoading = "g8gmt74";
var vars$a = { width: "var(--g8gmt70)", height: "var(--g8gmt71)", marginBottom: "var(--g8gmt72)" };
var loading_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  content: content$1,
  loading: loading$3,
  mobileLoading,
  vars: vars$a
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$E = "";
var mask = "_1cc4wia0";
var mask_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  mask
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$D = "";
var close = "_1y4batq4";
var popup$1 = "_1y4batq2";
var popupBody = "_1y4batq3";
var vars$9 = { borderRadius: "var(--_1y4batq0)", imgSize: "var(--_1y4batq1)" };
var popup_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  close,
  popup: popup$1,
  popupBody,
  vars: vars$9
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$C = "";
var container$5 = "_1ofykqlb";
var dotFlashing = "_1ofykqlf";
var dotFlashingAfter = "_1ofykqlh _1ofykqlf";
var dotFlashingBefore = "_1ofykqlg _1ofykqlf";
var img = "_1ofykqlc";
var loading$2 = "_1ofykqle";
var text$1 = "_1ofykqld";
var vars$8 = { borderRadius: { container: "var(--_1ofykql0)" }, size: { containerWidth: "var(--_1ofykql1)", containerHeight: "var(--_1ofykql2)", image: "var(--_1ofykql3)", dot: "var(--_1ofykql4)" }, space: { containerTop: "var(--_1ofykql5)", imgBottom: "var(--_1ofykql6)", textTop: "var(--_1ofykql7)", dotLeft: "var(--_1ofykql8)", afterDotLeft: "var(--_1ofykql9)" }, translateY: "var(--_1ofykqla)" };
var verifying_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  container: container$5,
  dotFlashing,
  dotFlashingAfter,
  dotFlashingBefore,
  img,
  loading: loading$2,
  text: text$1,
  vars: vars$8
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$B = "";
var container$4 = "_1kj7jza5";
var image$1 = "_1kj7jza6";
var refreshBtn = "_1kj7jza8";
var text = "_1kj7jza7";
var vars$7 = { space: { container: "var(--_1kj7jza0)", text: "var(--_1kj7jza1)" }, size: { image: "var(--_1kj7jza2)", btnWidth: "var(--_1kj7jza3)" }, btnLineHeight: "var(--_1kj7jza4)" };
var networkError_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  container: container$4,
  image: image$1,
  refreshBtn,
  text,
  vars: vars$7
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$A = "";
var btn = "l068vac";
var container$3 = "l068va6";
var content = "l068va7";
var help = "l068vab";
var image = "l068va9";
var imageWrap = "l068va8";
var title$3 = "l068vaa";
var vars$6 = { space: { title: "var(--l068va0)", help: "var(--l068va1)", btn: "var(--l068va2)", imageWrap: "var(--l068va3)" }, size: { image: "var(--l068va4)", btn: "var(--l068va5)" } };
var auditReject_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  btn,
  container: container$3,
  content,
  help,
  image,
  imageWrap,
  title: title$3,
  vars: vars$6
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$z = "";
var container$2 = "dp1ear3";
var vars$5 = { maxHeight: "var(--dp1ear0)", padding: "var(--dp1ear1)", margin: "var(--dp1ear2)" };
var container_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  container: container$2,
  vars: vars$5
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$y = "";
var contact$1 = "xenxvz6";
var countdown$1 = "xenxvza";
var resend = "xenxvz8";
var resendHint = "xenxvzb";
var resendWithError = "xenxvz9";
var resendWrap = "xenxvz7";
var subTitle$4 = "xenxvz5";
var vars$4 = { fontSize: { subTitle: "var(--xenxvz0)", contact: "var(--xenxvz1)" }, space: { contact: "var(--xenxvz2)", resendTop: "var(--xenxvz3)", countdownLeft: "var(--xenxvz4)" } };
var sms_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  contact: contact$1,
  countdown: countdown$1,
  resend,
  resendHint,
  resendWithError,
  resendWrap,
  subTitle: subTitle$4,
  vars: vars$4
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$x = "";
var forgot = "_18sj6hgf";
var forgotHint = "_18sj6hgh";
var forgotWithError = "_18sj6hgg";
var promptOk = "_18sj6hgp";
var step$1 = "_18sj6hgj";
var stepEmphasize$1 = "_18sj6hgn";
var stepImg$1 = "_18sj6hgo";
var stepInfo = "_18sj6hgl";
var stepNum = "_18sj6hgk";
var stepText$1 = "_18sj6hgm";
var steps$1 = "_18sj6hgi";
var subTitle$3 = "_18sj6hge";
var vars$3 = { subTitleBottom: "var(--_18sj6hg0)", subTitleTop: "var(--_18sj6hg1)", forgotTop: "var(--_18sj6hg2)", forgotErrorTop: "var(--_18sj6hg3)", forgotHintBottom: "var(--_18sj6hg4)", stepNumSize: "var(--_18sj6hg5)", stepNumRight: "var(--_18sj6hg6)", stepImgSize: "var(--_18sj6hg7)", numFontSize: "var(--_18sj6hg8)", space: { promptOk: { bottom: "var(--_18sj6hg9)", left: "var(--_18sj6hga)", right: "var(--_18sj6hgb)" }, stepImg: "var(--_18sj6hgc)" }, size: { ok: "var(--_18sj6hgd)" } };
var pin_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  forgot,
  forgotHint,
  forgotWithError,
  promptOk,
  step: step$1,
  stepEmphasize: stepEmphasize$1,
  stepImg: stepImg$1,
  stepInfo,
  stepNum,
  stepText: stepText$1,
  steps: steps$1,
  subTitle: subTitle$3,
  vars: vars$3
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$w = "";
var subTitle$2 = "_1ap883f2";
var vars$2 = { space: { subTitle: "var(--_1ap883f0)" }, subTitleFont: "var(--_1ap883f1)" };
var fourIcNo_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  subTitle: subTitle$2,
  vars: vars$2
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$v = "";
var step = "_18qyljo7";
var stepEmphasize = "_18qyljo8";
var steps = "_18qyljo6";
var subTitle$1 = "_18qyljo5";
var vars$1 = { space: { subTitle: "var(--_18qyljo0)", steps: "var(--_18qyljo1)", stepBottom: "var(--_18qyljo2)", verifyBtn: "var(--_18qyljo3)" }, stepsBorderRadius: "var(--_18qyljo4)" };
var verifiedBtn = "_18qyljob";
var verifyBtn = "_18qyljo9";
var verifyCountdown = "_18qyljoa";
var voice_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  step,
  stepEmphasize,
  steps,
  subTitle: subTitle$1,
  vars: vars$1,
  verifiedBtn,
  verifyBtn,
  verifyCountdown
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$u = "";
var androidHelpHint = "kmhebfv";
var cellularHint = "kmhebfm";
var contact = "kmhebfg";
var helpBody = "kmhebfu";
var helpBodyList = "kmhebfw";
var helpDesc = "kmhebft";
var helpHeader = "kmhebfp";
var helpHeaderContent = "kmhebfq";
var helpItem = "kmhebfx";
var helpPhoneImg = "kmhebfr";
var helpTitle = "kmhebfs";
var highlightStepText = "kmhebf10";
var info = "kmhebfi";
var infoImg = "kmhebfj";
var infoText = "kmhebfk";
var infoWrap = "kmhebfh";
var stepDesc = "kmhebf12";
var stepImg = "kmhebf13";
var stepStyling = "kmhebf11";
var stepText = "kmhebfz";
var stepTitle = "kmhebfy";
var subTitle = "kmhebff";
var switchHelp = "kmhebfl";
var switchHelpContent = "kmhebfo";
var switchToVoice = "kmhebfn";
var vars = { fontSize: { subTitle: "var(--kmhebf0)" }, space: { infoWrap: "var(--kmhebf1)", infoWrapTop: "var(--kmhebf2)", infoBottom: "var(--kmhebf3)", cellularHint: "var(--kmhebf4)", infoImgRight: "var(--kmhebf5)", toVoiceTop: "var(--kmhebf6)", helpContentPadding: "var(--kmhebf7)", helpHeaderPadding: "var(--kmhebf8)", helpBody: "var(--kmhebf9)", helpDescTop: "var(--kmhebfa)", stepTitleBottom: "var(--kmhebfb)" }, borderRadius: { infoWrap: "var(--kmhebfc)" }, size: { infoImg: "var(--kmhebfd)", toVoice: "var(--kmhebfe)" } };
var ip_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  androidHelpHint,
  cellularHint,
  contact,
  helpBody,
  helpBodyList,
  helpDesc,
  helpHeader,
  helpHeaderContent,
  helpItem,
  helpPhoneImg,
  helpTitle,
  highlightStepText,
  info,
  infoImg,
  infoText,
  infoWrap,
  stepDesc,
  stepImg,
  stepStyling,
  stepText,
  stepTitle,
  subTitle,
  switchHelp,
  switchHelpContent,
  switchToVoice,
  vars
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$t = "";
var countdown = "_1prw1ai4";
var desc = "_1prw1ai3";
var icon = "_1prw1ai1";
var title$2 = "_1prw1ai2";
var wrap = "_1prw1ai0";
var ipVerifyResult_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  countdown,
  desc,
  icon,
  title: title$2,
  wrap
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$s = "";
var errorInContainerBottom = "_1iv6ai71";
var pcContainer = "_1iv6ai70";
var pc_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  errorInContainerBottom,
  pcContainer
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$r = "";
var securityVerificationStyle_vanilla$q = "";
var securityVerificationStyle_vanilla$p = "";
var securityVerificationStyle_vanilla$o = "";
var securityVerificationStyle_vanilla$n = "";
var securityVerificationStyle_vanilla$m = "";
var securityVerificationStyle_vanilla$l = "";
var securityVerificationStyle_vanilla$k = "";
var securityVerificationStyle_vanilla$j = "";
var securityVerificationStyle_vanilla$i = "";
var securityVerificationStyle_vanilla$h = "";
var securityVerificationStyle_vanilla$g = "";
var securityVerificationStyle_vanilla$f = "";
var securityVerificationStyle_vanilla$e = "";
var securityVerificationStyle_vanilla$d = "";
var auditReject$1 = "_8ysvtm0";
var button$1 = "t56jpy0";
var container$1 = "_15xmvdk0";
var fourIcNo$1 = "ozduoy0";
var input$1 = "_16enzz60";
var ip = "gc0uf70";
var loading$1 = "nlsqi10";
var networkError$1 = "_1a8d7vg0";
var pin$1 = "pw8krd0";
var popup = "_1uhu02v0";
var slider$1 = "_1bcoxud0";
var sms$1 = "_1hiu58w0";
var title$1 = "xxfcbj0";
var verifying$1 = "_1q71xqt0";
var voice$1 = "c9i3ka0";
var index_css$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auditReject: auditReject$1,
  button: button$1,
  container: container$1,
  fourIcNo: fourIcNo$1,
  input: input$1,
  ip,
  loading: loading$1,
  networkError: networkError$1,
  pin: pin$1,
  popup,
  slider: slider$1,
  sms: sms$1,
  title: title$1,
  verifying: verifying$1,
  voice: voice$1
}, Symbol.toStringTag, { value: "Module" }));
var securityVerificationStyle_vanilla$c = "";
var securityVerificationStyle_vanilla$b = "";
var securityVerificationStyle_vanilla$a = "";
var securityVerificationStyle_vanilla$9 = "";
var securityVerificationStyle_vanilla$8 = "";
var securityVerificationStyle_vanilla$7 = "";
var securityVerificationStyle_vanilla$6 = "";
var securityVerificationStyle_vanilla$5 = "";
var securityVerificationStyle_vanilla$4 = "";
var securityVerificationStyle_vanilla$3 = "";
var securityVerificationStyle_vanilla$2 = "";
var securityVerificationStyle_vanilla$1 = "";
var securityVerificationStyle_vanilla = "";
var auditReject = "_1g7naof0";
var button = "zg771s0";
var container = "_1vbi5wi0";
var fourIcNo = "_1gx911l0";
var input = "miamzr0";
var loading = "_1mg2yez0";
var networkError = "_2840xv0";
var pin = "an3ngm0";
var slider = "_10bzmwg0";
var sms = "j1p6s0";
var title = "_14owznv0";
var verifying = "_1n3trk40";
var voice = "yqpvp10";
var index_css = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  auditReject,
  button,
  container,
  fourIcNo,
  input,
  loading,
  networkError,
  pin,
  slider,
  sms,
  title,
  verifying,
  voice
}, Symbol.toStringTag, { value: "Module" }));
export { auditReject_css as auditReject, button_css as button, container_css as container, fourIcNo_css as fourIcNo, input_css as input, ip_css as ip, ipVerifyResult_css as ipResult, loading_css as loading, mask_css as mask, index_css$1 as mobileTheme, networkError_css as networkError, pc_css as pc, index_css as pcTheme, pin_css as pin, popup_css as popup, slider_css as slider, sms_css as sms, title_css as title, vars$f as vars, verifying_css as verifying, voice_css as voice };
